import { IconDatabaseOff } from "@tabler/icons-react";
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia } from "@/components/ui/empty";
import { cn } from "@/lib/utils";

export function EditorEmptyState({ label, compact = false }: { label: string; compact?: boolean }) {
  return (
    <Empty className={cn("gap-2 px-4 py-8", compact && "min-h-0 py-6")}>
      <EmptyHeader>
        <EmptyMedia variant="icon" className="mb-3 text-muted-foreground">
          <IconDatabaseOff />
        </EmptyMedia>
        <EmptyDescription className="text-xs">{label}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
